import { render, staticRenderFns } from "./RoiCalc.vue?vue&type=template&id=3c48e31d&"
import script from "./RoiCalc.vue?vue&type=script&lang=js&"
export * from "./RoiCalc.vue?vue&type=script&lang=js&"
import style0 from "./RoiCalc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/kevin/code/websites/dataself-calc/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
installComponents(component, {VBtn,VDivider,VFlex,VLayout,VSlider})
